import React, { useState } from "react";
import BasicInfoSection from "../components/profile/BasicInfoSection";
import ContactInfoSection from "../components/profile/ContactInfoSection";
import AddressInfoSection from "../components/profile/AddressInfoSection";
import MyBreakcrumbs from "../components/MyBreadcrumbs";
import ChangePasswordSection from "../components/profile/ChangePasswordSection";

function UserProfile() {
  // State variables
  const [collapsedSections, setCollapsedSections] = useState({
    basicInfo: false,
    contactInfo: false,
    addressInfo: false,
    changePassword: false,
  });

  const toggleSection = (section) => {
    setCollapsedSections((prev) => ({ ...prev, [section]: !prev[section] }));
  };

  const breadcrumbs = [
    {
      label: "Home",
      href: "#",

      class: "text-[#2E37A4]",
    },
    { label: "Profile", class: "text-[#2E37A4]" },
  ];

  return (
    <div className="page-container relative h-full flex flex-auto flex-col px-4 sm:px-6 py-4 sm:py-6 md:px-8 md:pl-24">
      <div className="pt-2 pb-6">
        <MyBreakcrumbs data={breadcrumbs} />

        <div className=" bg-white   rounded-2xl mt-5">
          {/* Use the BasicInfoSection component */}
          <BasicInfoSection
            collapsed={collapsedSections.basicInfo}
            toggleSection={toggleSection}
            callType={'clinic'}
          />
          {/* Contact Information Section */}
          <ContactInfoSection
            collapsed={collapsedSections.contactInfo}
            toggleSection={toggleSection}
            callType={'clinic'}         
          />

          {/* Address Information Section */}
          <AddressInfoSection
            collapsed={collapsedSections.addressInfo}
            toggleSection={toggleSection}
            callType={'clinic'}  
          />

          {/* Change Password Section */}
          <ChangePasswordSection
            collapsed={collapsedSections.changePassword}
            toggleSection={toggleSection}
            callType={'clinic'}
          />
        </div>
      </div>
    </div>
  );
}

export default UserProfile;
